if(customElements.get("dynamic-content") === undefined) {
  class DynamicContent extends HTMLElement {
    constructor() {
      super();
      // Name of the dispatch event
      this.trigger_by = this.getAttribute('trigger-by');
      // Where in this.values will the trigger be in
      this.trigger_data = this.getAttribute('trigger-data');
      // Values on what's changing
      this.values = JSON.parse(this.getAttribute('data-values'));
      // Template ID
      this.template_id = this.getAttribute('data-template-id');

      // Default values
      this.default_values = this.getAttribute('default-values');
      if(this.default_values)
        this.default_values = JSON.parse(this.getAttribute('default-values'));
    }

    connectedCallback() {
      // if trigger is not empty
      if (this.trigger_by && this.template_id && this.values && this.trigger_data) {
        const that = this;
        document.addEventListener(this.trigger_by, 
          (e) => this.triggerHandler(e, that));
      } else {
        console.error('<dynamic-content></dynamic-content>: Attributes not set correctly');
        const warn = `
          {
            "trigger-by": "${this.trigger_by}",
            "data-template-id": "${this.template_id}",
            "data-values": "${this.values}",
            "trigger-data": "${this.trigger_data}"
          }
        `
        console.warn('Values provided for <dynamic-content>:', warn);
      }
    }

    triggerHandler(e, that) {
      let current = that.values;
      if(!current.length) return;
      
      const id = e.detail.variant.id.toString();
      let position = current[that.trigger_data].indexOf(id);
      let templateAttributes = {};

      if(position === -1) {
        current = that.default_values;
        position = 0
      }

      if(position !== -1) {
        const templates = document.querySelectorAll(that.template_id);

        templates.forEach(template => {
          Object.keys(current).forEach(key => {
            const value = current[key][position];
            const element = template.querySelector(`[${key}]`);
            const tag = element?.getAttribute(key);

            if(tag) {
              let ele;

              if(Object.values(templateAttributes).length > 1) {
                templateAttributes = {};
              }

              const hasValue = Object.values(templateAttributes).includes(element.getAttribute('class'));

              if(!hasValue) {
                element.innerHTML = '';
              }
  
              if(tag === 'img') {
                ele = document.createElement('img');
                ele.src = value;
                element.appendChild(ele);
              } else {
                ele = document.createElement(tag);
                ele.innerHTML = value;
              }
  
              element.appendChild(ele);
              templateAttributes[key] = element?.getAttribute('class') ?? null;
            }
          });
        });

        
      }
    }

    disconnectedCallback() {    
      // remove event listeners
      document.removeEventListener(this.trigger_by, this.triggerHandler);
    }
  } 

  // let the browser know that <my-element> is served by our new class
  customElements.define("dynamic-content", DynamicContent);
}

// TODO NEEDS DOCUMENTATION

if(customElements.get("simple-slider") === undefined) {
  class SimpleSlider extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
      this.slidesPerView = this.getAttribute('slides-per-view') || 1;
      this.loop = this.getAttribute('loop') === 'true' ? true : false;
      this.arrows = this.hasAttributes('arrows');
      this.thumbnails = this.getAttribute('thumbnails');
      this.loop = this.getAttribute('loop') === 'true' ? true : false || this.thumbnails === null ? false : true;
      this.slidesOffsetAfter = this.getAttribute('slidesOffsetAfter');
      this.effect = this.getAttribute('effect');
      this.pagination = this.getAttribute('pagination');
      this.breakpoints = this.getAttribute('breakpoints');
      this.autoHeight = this.getAttribute('autoHeight');
      this.videos = this.querySelectorAll('video');

      this.options = {
        // default options
        loop: this.loop,
        pagination: this.pagination ? {
          el: '.swiper-pagination',
          clickable: true
        } : false,
        effect: this.effect ? this.effect : 'slide',
        fadeEffect: this.effect ? {
          crossFade: true
        } : false,
        navigation: (this.thumbnails || this.arrows) ? {
          nextEl: `.${this.classList[0]} .swiper-button-next`,
          prevEl: `.${this.classList[0]} .swiper-button-prev`
        } : false,
        thumbs: this.thumbnails ? {
          swiper: this.thumbnails
        } : false,
        slidesOffsetAfter: this.slidesOffsetAfter ? parseInt(this.slidesOffsetAfter) : 0,
        watchSlidesVisibility: this.thumbnails ? true : false,
        watchSlidesProgress: this.thumbnails ? true : false,
        slidesPerView: this.slidesPerView,
        loopAddBlankSlides: false,
        spaceBetween: this.getAttribute('spaceBetween') || 0,
        autoHeight: this.autoHeight ? true : false,
        breakpoints: this.breakpoints ? JSON.parse(this.breakpoints) : false
      };
    }

    connectedCallback() {
      this.initSwiper();
    }

    disconnectedCallback() {
      // destroy swiper slider when custom element is removed from DOM
      this.swiper.destroy();
    }

    initSwiper() {
      if (typeof Swiper === 'undefined') return;
      // create swiper container and wrapper elements
      const container = document.createElement('div');
      container.classList.add('swiper-container');

      // get items inside this with the attribute wrap and add those items inside the container
      const wrap = this.querySelectorAll('[wrap]');

      if(wrap.length > 0) {
        wrap.forEach((wrap) => {
          container.appendChild(wrap);
        });
      }
      const wrapper = document.createElement('div');
      wrapper.classList.add('swiper-wrapper');

      // add slides to wrapper element
      const slides = this.querySelectorAll('[data-slide]');
      slides.forEach((slide) => {
        slide.classList.add('swiper-slide');
        wrapper.appendChild(slide);
      });

      // append container and wrapper elements to custom element
      container.appendChild(wrapper);

      if(this.pagination) {
        const pagination = document.createElement('div');
        pagination.classList.add('swiper-pagination');
        container.appendChild(pagination);
      }
      
      this.appendChild(container);
      // initialize swiper slider
      this.swiper = new Swiper(container, this.options);
      setTimeout(() => {
        this.style.opacity = '1';
        this.style.maxHeight = 'unset';
        const swiperWrapper =this.querySelector('.swiper-wrapper');
        const swiperWrapperHeight = swiperWrapper.offsetHeight;
        if(!this.classList.value.includes('pdp-slider'))
          swiperWrapper.style.minHeight = swiperWrapperHeight + 40 + 'px';

        if(this.videos.length > 0) {
          this.ifHasVideos();
        }
      }, 100);
    }

    ifHasVideos = () => {
      this.swiper.on('slideChange', () => {
        this.videos.forEach(video => {
          video.pause();
        });

        const currentSlide = this.swiper.activeIndex;
        const activeSlide = this.swiper.slides[currentSlide];

        const activeVideo = activeSlide.querySelector('video');

        if(activeVideo) {
          const video = Array.from(this.videos).filter(vid => vid.src === activeVideo.src)

          if(video.length > 0) {
            video[0].play();
          }
        }
      });
    }

  }

  customElements.define('simple-slider', SimpleSlider);
}

if(customElements.get("custom-modal") === undefined) {
  class Modal extends HTMLElement {
    constructor() {
      super();
      this.type = this.dataset.type;
      this.position = this.dataset.position;
      this.triggerType = this.dataset.triggerType;
      this.trigger = this.triggerType === 'single' 
        ? this.previousElementSibling.closest(this.dataset.trigger)
        : document.querySelectorAll(this.dataset.trigger);
    }
    
    connectedCallback() {
      this.triggerType === 'single' 
        ? this.trigger.addEventListener('click', this.showModal)
        : this.trigger.forEach(trigger => {
          trigger.addEventListener('click', this.showModal);
        });

      this.classList.add(`modal--${this.type}`);

      this.createModal();
    }

    showModal = () => {
      this.classList.remove('modal--closed');
      this.classList.add('modal--open');
      document.addEventListener('click', this.hideModalOverlay);
    }

    hideModal = () => {
      this.classList.remove('modal--open');
      this.classList.add('modal--closed');
      
      // emit a close event
      this.dispatchEvent(new CustomEvent('modal--close', { 
        detail: {
          dropdown: this
        },
        bubbles: true,
        cancelable: true
      }));

      document.removeEventListener('click', this.hideModalOverlay);
    }

    hideModalOverlay = (e) => {
      if(e.target.classList.contains('modal--open')) this.hideModal();
    }

    createModal = () => {
      // create modal wrapper
      const content = this.innerHTML;
      this.innerHTML = '';
      const wrapper = document.createElement('div');
      wrapper.classList.add('modal--wrapper');
      wrapper.innerHTML = content;

      this.appendChild(wrapper);

      // create close button
      const closeBtn = document.createElement('button');
      closeBtn.classList.add('modal--close');
      closeBtn.setAttribute('aria-label', 'Close Modal');
      const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('viewBox', '0 0 22 22');
      svg.setAttribute('width', '22');
      svg.setAttribute('height', '22');
      svg.innerHTML = `<path d="M1.25684 1L21.0004 21" stroke="#ABAEAB" stroke-width="2"/><path d="M20.7434 1L0.999843 21" stroke="#ABAEAB" stroke-width="2"/>`;
      closeBtn.appendChild(svg);
      closeBtn.addEventListener('click', this.hideModal);

      this.appendChild(closeBtn);
    }

    disconnectedCallback() {
      // browser calls this method when the element is removed from the document
      Array.from(this.trigger).forEach(trigger => {
        trigger.removeEventListener('click', this.showModal);
      });
    }

  } 

  customElements.define("custom-modal", Modal);

}

// ANCHOR Nav Dropdown

if(customElements.get("nav-dropdown") === undefined) {
  class NavDropdown extends HTMLElement {
    constructor() {
      super();
      this.triggerClass = 'active-nav-dropdown';
      this.trigger = this.querySelector('[data-trigger]');
      this.dropdown = this.querySelector('[data-dropdown]');
      this.lockScroll = this.hasAttribute('data-lock-scroll');
    }

    connectedCallback() {
      this.trigger.addEventListener('click', this.showDropdown);
    }

    showDropdown = () => {
      const isActive = this.dropdown.classList.contains(this.triggerClass);
      document.querySelectorAll('nav-dropdown').forEach(dropdown => {
        dropdown.hideDropdown();
      });
      
      if(isActive) return;

      this.trigger.dataset.trigger = 'open';
      this.dropdown.classList.add(this.triggerClass);

      const searchInput = this.dropdown.querySelector('[data-search-input]');
      if (searchInput) {
          searchInput.focus();
      }
      
      if(this.lockScroll)
        document.querySelector('body').classList.add('nav-dropdown-lock');

      document.addEventListener('click', this.hideOutsideClick);
    }

    hideOutsideClick = (e) => {
      const hideDropdown = e.target.closest('[data-dropdown]') !== this.dropdown 
          && e.target.closest('[data-trigger]') !== this.trigger 
          && e.target !== this.trigger 
          && e.target !== this.dropdown;

      if(hideDropdown) this.hideDropdown();
    }

    hideDropdown = () => {
      this.trigger.dataset.trigger = 'close';
      this.dropdown.classList.remove(this.triggerClass);
      document.removeEventListener('click', this.hideOutsideClick);

      // emit a close event
      this.dispatchEvent(new CustomEvent('close-dropdown', { 
        detail: {
          dropdown: this.dropdown
        },
        bubbles: true,
        cancelable: true
      }));

      if(this.lockScroll) 
        document.querySelector('body').classList.remove('nav-dropdown-lock');
    }

    disconnectedCallback() {
      // browser calls this method when the element is removed from the document
      this.trigger.removeEventListener('click', this.showDropdown);
    }
  } 

  customElements.define("nav-dropdown", NavDropdown);

} 

if(customElements.get("accordion-element") === undefined) {
  class Accordion extends HTMLElement {
    constructor() { 
      super();
      this.trigger = this.querySelector('[data-trigger]');
      this.content = this.querySelector('[data-content]');
    }

    connectedCallback() {
      this.trigger.addEventListener('click', this.toggleAccordion);
    }

    toggleAccordion = () => {
      const isOpen = this.content.classList.contains('open');
      
      // open / close the current accordion
      if(isOpen) {
        this.content.classList.remove('open');
        this.trigger.classList.remove('open');
      } else {
        // close all accordions to open the current one
        this.closeAccordion();

        this.content.classList.add('open');
        this.trigger.classList.add('open');

      }
      
    }

    closeAccordion = () => {
      document.querySelectorAll('accordion-element').forEach(accordion => {
        accordion.content.classList.remove('open');
        accordion.trigger.classList.remove('open');
        // emit a close event
        this.dispatchEvent(new CustomEvent('close-dropdown', { 
          detail: {
            dropdown: this.dropdown
          },
          bubbles: true,
          cancelable: true
        }));
      });
    }
  }

  customElements.define("accordion-element", Accordion);
}

if(customElements.get("search-element") === undefined) {
  class Search extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('[data-search-input]'); 
      this.icon = this.querySelector('[data-search-icon]');
      this.results = this.querySelector('[data-search-results]');
      this.localization_url = Shopify.routes.root;
    }

    connectedCallback() {
      this.icon?.addEventListener('click', () => this.input.focus());
      this.input.addEventListener('input', this.debounce(this.search, 500));

      // Looks for a close-dropdown event (coming from nav-dropdown component or any other component)
      document.addEventListener('close-dropdown', (e) => {
        this.input.value = '';
        this.results.innerHTML = '';
      });
    }

    debounce = (func, wait) => {
      let timeout;
      return function(...args) {
        const context = this;
        const later = () => {
          timeout = null;
          func.apply(context, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    }

    search = async (e) => {
      const term = e.target.value;
      if(term.length >= 1) {
        const response = await fetch('/search/suggest.json?q=' + term + '&resources[type]=product,article,page&fields=title,body,author')
        let res = await response.json();
        res = res.resources.results;
        const activeResults = [];
        this.results.innerHTML = '';

        for (const [key, value] of Object.entries(res)) {
          if(value.length > 0) {
            activeResults.push({
              key: key,
              value: value
            });
          } else {
            res[key] = [];
          }
        }

        if(activeResults.length > 0) {
          this.createResults(activeResults);
        } else {
          this.results.innerHTML = '<p>No results found</p>';
        }
      } else {
        this.results.innerHTML = '';
      }
    }

    createResults = (res) => {
      const mainTitle = document.createElement('h3');
      mainTitle.innerHTML = 'Search Results';
      this.results.appendChild(mainTitle);

      const resultsWrapper = document.createElement('div');
      resultsWrapper.classList.add('search-results--wrapper');

      res.forEach(result => {
        const resTitle = document.createElement('h4');
        resTitle.innerHTML = result.key;
        resultsWrapper.appendChild(resTitle);
        result.value.forEach(item => {
          const resItem = document.createElement('a');
          resItem.classList.add('search-results--item');
          resItem.href = this.localization_url !== '/' 
            ? `${this.localization_url.substring(0, this.localization_url.length - 1)}${item.url}` 
            : item.url;
          resItem.innerHTML = item.title;
          resultsWrapper.appendChild(resItem);
        });
      });

      this.results.appendChild(resultsWrapper);
    }
  }

  customElements.define("search-element", Search);
}

if(customElements.get("single-image-slider") === undefined) {
  class SingleImageSlider extends HTMLElement {
    constructor() {
      super();
      this.viewport = null;
      this.slides = [];
      this.prevButton = null;
      this.nextButton = null;
      this.navButtons = [];
      this.currentSlide = 0;
      this.previousSlide = 0;
      this.totalSlides = 0;
      this.slideWidth = 0;
      this.slidesPerView = 1;

      this.autoplay = false;
      this.autoplaySpeed = 5000;
      this.arrows = false;
      this.dots = false;
      this.loop = false;

      this.isDragging = false;
      this.startX = 0;
      this.scrollStart = 0;
      this.direction = null;
      this.dragSpeed = 1.8;
    }

    // Calculate slide width, handling cases where slides might not be visible yet
    _calculateSlideWidth() {
      if (this.slides && this.slides.length > 0) {
        // Try to get the actual width first
        let width = this.slides[0].offsetWidth;

        // If still 0 (likely because slides are hidden in modal), try computed styles
        if (width === 0) {
          const computedStyle = window.getComputedStyle(this.slides[0]);
          const cssWidth = computedStyle.width;

          if (cssWidth && cssWidth !== 'auto' && cssWidth !== '0px') {
            // Parse CSS width (e.g., "300px" -> 300)
            const match = cssWidth.match(/(\d+)px/);
            if (match) {
              width = parseInt(match[1], 10);
            }
          }
        }

        this.slideWidth = width;
      } else {
        this.slideWidth = 0;
      }
    }

    // Public method to recalculate dimensions (call when element becomes visible)
    recalculateDimensions() {
      this._calculateSlideWidth();
    }

    connectedCallback() {
      this.viewport = this.querySelector('.carousel__viewport');
      this.slides = this.viewport.querySelectorAll('.carousel__slide');

      this.prevButton = this.querySelector('.carousel__prev');
      this.nextButton = this.querySelector('.carousel__next');
      this.navButtons = this.querySelectorAll('.carousel__navigation-button');

      this.autoplay = this.hasAttribute('autoplay');
      this.autoplaySpeed = this.getAttribute('autoplay');
      this.arrows = this.hasAttribute('arrows');
      this.dots = this.hasAttribute('dots');
      this.loop = this.hasAttribute('loop');
      this.slidesPerView = this.getAttribute('slidesPerView');

      this.totalSlides = this.slides.length;
      this._calculateSlideWidth();

      if (!this.viewport || this.slides.length === 0) return;

      // Set pointer styles
      this.viewport.style.scrollBehavior = 'smooth';
      this.viewport.style.cursor = 'grab';

      // Dragging Event listeners
      if(window.innerWidth > 768) {
        this.viewport.addEventListener('pointerdown', this.onDragStart.bind(this));
        this.viewport.addEventListener('pointermove', this.onDragMove.bind(this));
        this.viewport.addEventListener('pointerup', this.onDragEnd.bind(this));
        this.viewport.addEventListener('pointerleave', this.onDragEnd.bind(this));
      } else {
        this.viewport.addEventListener('touchstart', this.onDragStart.bind(this));
        this.viewport.addEventListener('touchmove', this.onDragMove.bind(this));
        this.viewport.addEventListener('touchend', this.onDragEnd.bind(this));
        this.viewport.addEventListener('touchleave', this.onDragEnd.bind(this));
      }

      this.viewport.addEventListener('scroll', this.setActiveSlide.bind(this));

      // Not supported on Firefox and Safari
      // this.viewport.addEventListener('scrollsnapchanging', this.setActiveSlide.bind(this));
      // this.viewport.addEventListener('scrollsnapchange', this.setActiveSlide.bind(this));
      // this.viewport.addEventListener('scrollend', this.setActiveSlide.bind(this));

      // Next / previous event listeners
      if (this.arrows) {
        this.prevButton?.addEventListener('click', this.prevSlide.bind(this));
        this.nextButton?.addEventListener('click', this.nextSlide.bind(this));
      }
      
      // Navigation (Dots) event listeners
      if (this.dots) {
        this.navButtons.forEach((button, index) => {
          button.addEventListener('click', () => this.goToSlide(index));
        });
      }

      // Keyboard nav
      this.slides.forEach((slide, index) => {
        slide.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') this.prevSlide();
          if (e.key === 'ArrowRight') this.nextSlide();
        });
      });

      // Initialize position
      this.goToSlide(0);

      if (this.autoplay) {
        this.interval = setInterval(() => {
          this.nextSlide();
        }, this.autoplaySpeed);
      }
    }

    // setDirection(e) {
    //   const x = window.innerWidth > 768 ? e.pageX : e.changedTouches[0].pageX;
    //   const walk = (x - this.startX) * this.dragSpeed;
    //   this.direction = walk > 0 ? "left" : "right";
    // }

    onDragStart(e) {
      this.previousSlide = this.currentSlide;
      this.isDragging = true;
      this.viewport.style.cursor = 'grabbing';
      this.startX = window.innerWidth > 768 ? e.pageX : e.changedTouches[0].pageX;
      this.scrollStart = this.viewport.scrollLeft;
    }

    onDragMove(e) {
      if (!this.isDragging) return;
      const x = window.innerWidth > 768 ? e.pageX : e.changedTouches[0].pageX;
      const walk = (x - this.startX) * this.dragSpeed;
      this.direction = walk > 0 ? "left" : "right";

      if(window.innerWidth > 768) {
        this.viewport.scrollLeft = this.scrollStart - walk;
      }
      // this.setDirection(e);
    }

    onDragEnd(e) {

      if(window.innerWidth < 768) {
        this.isDragging = true;
      }

      if(this.loop) {
        if(this.direction === "left" && (this.currentSlide === 0 && this.previousSlide === 0)) {
          this.goToSlide(this.totalSlides - 1);
        } else if(this.direction === "right" && this.currentSlide === this.totalSlides - 1 && this.previousSlide === this.totalSlides - 1) {
          this.goToSlide(0);
        }
      }

      if (!this.isDragging) return;
      this.isDragging = false;
      this.viewport.style.cursor = 'grab';
    }

    goToSlide(index) {
      if (index < 0) {
        index = this.totalSlides - 1;
      } else if (index >= this.totalSlides) {
        index = 0;
      }

      this.currentSlide = index;
      this.viewport.scrollTo({
        left: this.slideWidth * index,
        behavior: 'smooth',
      });

      // this.slides[index]?.focus?.();
    }

    prevSlide() {
      this.goToSlide(this.currentSlide - 1);
    }

    nextSlide() {
      this.goToSlide(this.currentSlide + 1);
    }

    setActiveSlide(e) {
      // If slideWidth is 0, try to recalculate dimensions (modal might just have opened)
      if (this.slideWidth === 0) {
        this._calculateSlideWidth();
      }

      // If still 0 after recalculation, skip the update
      if (this.slideWidth === 0) {
        console.warn('SingleImageSlider: Cannot calculate slide width, skipping setActiveSlide');
        return;
      }

      const slideIndex = Math.floor(this.viewport.scrollLeft / this.slideWidth);
      const slide = this.querySelector(`[data-slide-index="${slideIndex}"]`);

      // Remove active class from all slides
      this.slides.forEach(slide =>
        slide.classList.remove('is-active'));

      // Remove active class from all nav dots
      this.navButtons.forEach(btn => 
        btn.classList.remove('is-active'));

      // Set current slide
      this.currentSlide = Number(slide?.dataset.slideIndex);

      // Add active class to current slide
      slide.classList.add('is-active');

      // Add active class to current dot
      this.navButtons.forEach((btn, i) => 
        btn.classList.toggle('is-active', i === this.currentSlide));
    }
  }

  customElements.define('single-image-slider', SingleImageSlider);
}

/* 
  How TO USE:
  class MyElement extends HTMLElement {
    constructor() {
      super();
      // element created
    }

    connectedCallback() {
      // browser calls this method when the element is added to the document
      // (can be called many times if an element is repeatedly added/removed)
    }

    disconnectedCallback() {
      // browser calls this method when the element is removed from the document
      // (can be called many times if an element is repeatedly added/removed)
    }

    static get observedAttributes() {
      // returns an array of attributes that the element can observe
      return [];
    }

    attributeChangedCallback(name, oldValue, newValue) {
      // called when one of attributes listed above is modified
    }

    adoptedCallback() {
      // called when the element is moved to a new document
      // (happens in document.adoptNode, very rarely used)
    }

    // there can be other element methods and properties
  } 


  // let the browser know that <my-element> is served by our new class
  customElements.define("my-element", MyElement);
*/

/* 
  How To Use:

  <dynamic-content 
    data-trigger=".atc-option"
    data-trigger-attribute="data-variant-id"
    data-trigger-data="variant_availablity"
    data-values='{{ content }}'> 

    CONTENT HERE

  </dynamic-content>

  How will the trigger will be triggered:
    trigger-by="custom" | Required
    !! IMPORTANT !!
      "custom" should be the same name as the event being triggered
      When dispatching the event, you should return trigger-data,
      so we can know which is the information that is changing

  Which element in data-values will be the relationship between the trigger and the dynamic content:
    trigger-data="Class ID or Data Attribute" | Required

  Values to change:
    data-values='Object or Array' | required

  Template ID: | required
    data-template-id="Class ID or Data Attribute of the template inside <dynamic-content></dynamic-content>"

  !! IMPORTANT !!
    The template ID should be the same as the template ID in the <dynamic-content></dynamic-content>
    Where the dynamic content is going to be placed should have the same name as the "data-values" properties
    and should contain which tag to use for that property

  Example: 

    <div class="atc-option" data-variant-id="1"></div>
    <div class="atc-option" data-variant-id="2"></div>
    <div class="atc-option" data-variant-id="3"></div>

    <dynamic-content 
      default-values='{{ default }}'
      trigger-by="changeInformation"
      trigger-data="variant_availablity"
      data-values='{{ content }}'
      data-template-id=".pdp-extra-info">

      <div class="pdp-extra-info">
        <div class="pdp-extra-info">
          <div class="ei-image" pre-order-message-icon="img"></div>
          <div class="ie-contents" heading="h2" subheading="h3"></div>
        </div>
      </div>
      
      trigger-by="custom" The event will be triggered by the custom event in another place
      In data-value, we should have a property that is called (in this case) variant_availablity
      variant_availablity will have the data-variant-id values
      
      Example of {{ content }} in data-values:
      {
        "heading": [xx,xx,xx],
        "subheading": [xx,xx,xx],
        "img": [xx,xx,xx],
        "variant_availablity": [1,2,3]
      }

    </dynamic-content>
*/